import { Autocomplete, Button, FormControl, InputLabel, MenuItem, Select, TextField, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik } from "formik";
import axios from 'axios';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import { Stack } from '@mui/system';
import { Image } from 'cloudinary-react'
import { useUpdateSmartphoneMutation, useGetAllBrandsQuery, useGetAllStoragesQuery, useGetAllColorsQuery, useGetAllGroupsQuery, useGetAllModelsQuery, useAddGroupMutation } from '../../../../features/fullApi';
import { basicSchema } from "./validation";
import { useTheme } from '@mui/material/styles';
import { toast } from 'react-hot-toast';

const EditSmartphone = () => {
  window.scrollTo(0, 0);
  const params = useParams()
  const [smartphone, setSmartphone] = useState({})
  const user = JSON.parse(localStorage.getItem('user'))

  const [reqDone, setReqDone] = useState(false)
  const [finished, setFinished] = useState(false)

  const [brand, setBrand] = useState("");
  const [selectedStorages, setSelectedStorages] = useState([]);
  const [color, setColor] = useState("");
  const [selectedFile, setSelectedFile] = useState([]);

  const [model, setModel] = useState("");
  const [storage, setStorage] = useState("");

  const {data: brands, error: brandsError, isLoading: isLoadingBrands} = useGetAllBrandsQuery()
  const {data: storages, error: storagesError, isLoading: isLoadingStorages} = useGetAllStoragesQuery()
  const {data: colors, error: colorsError, isLoading: isLoadingColors} = useGetAllColorsQuery()
  const {data: groups, error: groupsError, isLoading: isLoadingGroups} = useGetAllGroupsQuery()
  const {data: models, error: modelsError, isLoading: isLoadingModels} = useGetAllModelsQuery()


  useEffect(() => {
    const getSmartphone = async () => {
      const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/smartphones/find/${params.id}`)
      .then(res => {
        setSmartphone(res.data)
        setReqDone(true)
      })
      .catch(err => console.log(err))
    }
    getSmartphone()
  }, [])



 useEffect(() => {
  const getBrand = async () => {
    const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/brands/find/${smartphone.brandId}`)
    .then(res => {
      setBrand(res.data)
    })
    .catch(err => console.log(err))
  }
  getBrand()
}, [reqDone])


useEffect(() => {
  const getStorages = async () => {
    smartphone?.storages?.map(async (storage) => {
      const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/storages/find/${storage._id}`)
        .then(res => {
          setSelectedStorages(selectedStorages => [...selectedStorages, res.data]);
        })
        .catch(err => console.log(err)) 
  })
}
  getStorages()
  setFinished(true)
}, [reqDone])


useEffect(() => {
  const getColor = async () => {
    const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/colors/find/${smartphone.colorId}`)
    .then(res => {
      setColor(res.data)
    })
    .catch(err => console.log(err))
  }
  getColor()
}, [reqDone])

useEffect(() => {
  const getStorage = async () => {
    const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/storages/find/${smartphone.storageId}`)
    .then(res => {
      setStorage(res.data)
    })
    .catch(err => console.log(err))
  }
  getStorage()
}, [reqDone])


useEffect(() => {
  const getModel = async () => {
    const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/models/find/${smartphone.modelId}`)
    .then(res => {
      console.log("RES", res)
      setModel(res.data)
      setReqDone(true)
    })
    .catch(err => console.log(err))
  }
  getModel()
}, [reqDone])

  useEffect(() => {
    values.brands = brands
  }, [brands])

  useEffect(() => {
    values.storages = storages
  }, [storages])

  useEffect(() => {
    values.colors = colors
  }, [colors])

  useEffect(() => {
    values.models = models
  }, [models])

  const handleBrand = async (event) => {
    const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/brands/find/${event.target.value}`)
    .then(res => {
      setBrand(res.data)
    })
    .catch(err => console.log(err))
  };

  const handleColor = async (event) => {
    const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/colors/find/${event.target.value}`)
    .then(res => {
      setColor(res.data)
    })
    .catch(err => console.log(err))
  };

  const handleModel = async (event) => {
    const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/models/find/${event.target.value}`)
    .then(res => {
      setModel(res.data)
    })
    .catch(err => console.log(err))
  };

  const handleStorage = async (event) => {
    const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/storages/find/${event.target.value}`)
    .then(res => {
      setStorage(res.data)
    })
    .catch(err => console.log(err))
  };

useEffect(() => {
      const fields = ['title', 'desc', 'img', 'brandId', 'modelId', 'storageId', 'quantity', 'colorId', 'price'];
      fields.forEach(field => setFieldValue(field, smartphone[field], false));
}, [smartphone]);

const [smartphoneImgLink, setSmartphoneImgLink] = useState(smartphone.img)
const [showBtn, setShowBtn] = useState(false)
const uploadImage = async () => {
  const formData = new FormData()
  formData.append("file", selectedFile)
  formData.append("upload_preset", "zt8iigue")
  const data = await axios.post("https://api.cloudinary.com/v1_1/deqqgmfxk/image/upload", formData)
  .then(res => {
    setSmartphoneImgLink(res.data.secure_url)
    setShowBtn(true)
  })
};

function inFirstOnly(list1, list2) {
  console.log("Called in first only", list1)
  console.log("Called in first only", list2)
  return operation(list1, list2);
}

function operation(list1, list2, isUnion) {
  var result = [];
  
  for (var i = 0; i < list1.length; i++) {
      var item1 = list1[i],
          found = false;
      for (var j = 0; j < list2.length && !found; j++) {
          found = item1._id === list2[j]._id
      }
      if (found === !!isUnion) {
          result.push(item1);
      }
  }

  setOptionz(result)
  return result;
}

const [check, setCheck] = useState(true)

const [optionz, setOptionz] = useState([])
if(check) {
  if(selectedStorages?.length >= smartphone?.storages?.length) {
    console.log("storages", storages)
    console.log("selectedStorages", selectedStorages)
    let options = inFirstOnly(storages, selectedStorages)
    setOptionz(options)
    setCheck(false)
  }
}


  //constructing the boolean colors checked array
      const [groupsObj, setGroupsObj] = useState({})
  
      useEffect(() => {
        console.log("GROUP ERROR", groupsError)
        if(!isLoadingGroups) {
          console.log("GROUPS#####", groups)
          Object.keys(groups).forEach(ele => {
            let key = groups[ele].groupName
              groupsObj[key] = groups[ele]._id;
          });
        }
      }, [groups, isLoadingGroups])

const [updateSmartphone] = useUpdateSmartphoneMutation()
const [addGroup] = useAddGroupMutation()

const onSubmit = async(values, actions) => {
  if(groupsObj[brand.brandName + " " + model.modelName + " " + storage.amount + storage.type]?.length>0) {
    updateSmartphone({_id: smartphone._id, title: brand.brandName + " " + model.modelName  + " " + color.colorName + " " + storage.amount + storage.type, desc: values.desc, groupId: groupsObj[brand.brandName + " " + model.modelName + " " + storage.amount + storage.type], storageId: storage._id, brandId: brand._id, modelId: model._id, colorId: color._id, price: values.price, quantity: values.quantity, img: smartphoneImgLink}, { 
      headers: {
        'Token': `Bearer ${user?.accessToken}`
      }
    })
    .then(res => {
      toast.success(`${brand.brandName + " " + model.modelName  + " " + color.colorName + " " + storage.amount + storage.type} successfully created`)
    })
    .catch((e) => {
      toast("Product already exists")
      console.log("e is", e)
    })
} else {
  addGroup({groupName: brand.brandName + " " + model.modelName + " " + storage.amount + storage.type})
  .then(res => {
    updateSmartphone({_id: smartphone._id, title: brand.brandName + " " + model.modelName  + " " + color.colorName + " " + storage.amount + storage.type, desc: values.desc, groupId: res.data._id, storageId: storage._id, modelId: model._id, brandId: brand._id, colorId: color._id, price: values.price, img: smartphoneImgLink}, { 
      headers: {
        'Token': `Bearer ${user?.accessToken}`
      }
    })
    .then(res => {
      toast.success(`${brand.brandName + " " + model.modelName + " " + color.colorName + " " + storage.amount + storage.type} successfully created`)
    })
    .catch((e) => {
      toast("Product already exists")
      console.log("e is", e)
    })
  })
  .catch(err => {
    console.log("error when creating new group")
  })
}
navigate('/smartphones/1')
}

  const {
    values,
    errors,
    touched,
    isSubmitting,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: {
      title: smartphone?.title,
      desc: smartphone?.desc,
      img: smartphone?.img,
      brand: smartphone?.brandId,
      group: smartphone?.groupId,
      storage: smartphone?.storageId,
      color: smartphone?.colorId,
      model: smartphone?.modelId,
      price: smartphone?.price,
      quantity: smartphone?.quantity
    },
    validationSchema: basicSchema,
    onSubmit,
  });

  const navigate = useNavigate()

  const onFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
    uploadImage()
  };

  const theme = useTheme()

  const isXs= useMediaQuery(theme.breakpoints.down('xs'));
  const isSm= useMediaQuery(theme.breakpoints.down('sm'));
  const isMd= useMediaQuery(theme.breakpoints.down('md'));
  const isLg= useMediaQuery(theme.breakpoints.down('lg'));
  const isXl= useMediaQuery(theme.breakpoints.down('xl'));

  const renderMobileEditSmartphone = () => (
    <div id="formContainer" className={isMd ? "mobile" : ""} style={{width:'100%', height:'100%'}}>

    {(smartphone && finished) &&
    <form onSubmit={handleSubmit} autoComplete="off" id="registerForm">
      <h3 className="center">Edit {smartphone.title}</h3>
      <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
        <TextField
          id="desc"
          type="text"
          margin="dense"
          value={values.desc}
          onChange={handleChange}
          onBlur={handleBlur}
          focused
          label={"Desc"}
          multiline
          rows={5}
        />
      </FormControl>
      {errors.desc && touched.desc && (
        <p className="error">{errors.desc}</p>
      )}

      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '15px'}}>
        <Image cloudName="deqqgmfxk"  publicId={smartphoneImgLink ? smartphoneImgLink : smartphone.img} style={{width: '200px', height: '200px', objectFit:'cover', objectPosition:'center'}}/>     
      </div>
      <Stack direction="row" justifyContent="space-between" sx={{marginBottom: '10px'}}>
          <Button  sx={{width: '150px'}} variant="contained" color="secondary" size="small" component="label">
            Upload
            <input hidden accept="image/*" multiple type="file" name="img" id="input" onChange={onFileChange}/>
          </Button>
          <Button variant="contained" size="small" sx={{width: '150px'}} onClick={() => uploadImage()}>Save to cloud</Button>
        </Stack>

        <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
                  <InputLabel id="brand">Brand</InputLabel>
                  <Select
                    id="brand"
                    value={brand._id ? brand._id : brand}
                    label="Brand"
                    focused
                    onChange={handleBrand}
                    name="brand"
                    margin="dense"
                  >
                      {brands?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.brandName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
                  <InputLabel id="model">Model</InputLabel>
                  <Select
                    id="model"
                    value={model._id ? model._id : model}
                    label="Model"
                    focused
                    onChange={handleModel}
                    name="model"
                    margin="dense"
                  >
                      {models?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.modelName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
                  <InputLabel id="storage">Storage</InputLabel>
                  <Select
                    id="storage"
                    value={storage._id ? storage._id : storage}
                    label="Storage"
                    focused
                    onChange={handleStorage}
                    name="storage"
                    margin="dense"
                  >
                      {storages?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.amount + option.type}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
                  <InputLabel id="color">Color</InputLabel>
                  <Select
                    id="color"
                    value={color._id ? color._id : color}
                    label="Color"
                    onChange={handleColor}
                    name="color"
                  >
                      {colors?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.colorName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}}>
      <TextField
          id="quantity"
          type="number"
          margin="dense"
          value={values.quantity}
          focused
          onChange={handleChange}
          onBlur={handleBlur}
          label={"Quantity"}
          size="small"
        />
      </FormControl>
      {errors.quantity && touched.quantity && (
        <p className="error">{errors.quantity}</p>
      )}

    <FormControl fullWidth style={{marginBottom: '10px'}}>
    <TextField
        id="price"
        type="number"
        margin="dense"
        value={values.price}
        onChange={handleChange}
        onBlur={handleBlur}
        label={"Price"}
        focused
        size="small"
      />
      {errors.price && touched.price && (
        <p className="error">{errors.price}</p>
      )}
      </FormControl>







      <div className="btnContainer">
        <Stack direction="row" spacing={2}>
          {smartphone?.img ?
              (<Button variant="contained" size="small"color="primary" id="submitBtn" type="submit">
              Update
            </Button>) : "Please upload a smartphone image and you will be able to submit"
          } 
          <Button variant="contained" startIcon={<ShoppingBasketIcon />} size="small" color="secondary" id="submitBtn" type="submit" onClick={() => navigate("/smartphones")}>
            Shop
          </Button>
        </Stack>
      </div>
    </form>
  }

  </div>
  )

  const renderTabletEditSmartphone = () => (
    <div id="formContainer" className={isMd ? "mobile" : ""}>

    {(smartphone && finished) &&
    <form onSubmit={handleSubmit} autoComplete="off" id="registerForm">
      <Typography variant="h6" className="center">Edit Smartphone {smartphone.title}</Typography>
      <TextField
        id="title"
        type="text"
        value={values.title}    
        onChange={handleChange}
        onBlur={handleBlur}
        label={values.title ? "" : "Title"}
        margin="dense"
      />
      {errors.title && touched.title && <p className="error">{errors.title}</p>}

      <TextField
        id="desc"
        type="text"
        margin="dense"
        value={values.desc}
        onChange={handleChange}
        onBlur={handleBlur}
        label={values.desc ? "" : "Desc"}
      />
      {errors.desc && touched.desc && (
        <p className="error">{errors.desc}</p>
      )}

      <Image cloudName="deqqgmfxk"  publicId={smartphoneImgLink ? smartphoneImgLink : smartphone.img} style={{width: '300px', height: '300px', objectFit:'cover', objectPosition:'center'}}/>
      <Stack style={{marginBottom:'20px'}}>
        <Button variant="contained" color="secondary" component="label" style={{marginBottom: '10px'}}>
          Upload
          <input hidden accept="image/*" multiple type="file" name="img" id="input" onChange={onFileChange}/>
        </Button>
        <Button variant="contained" size="small" style={{width: '250px'}} onClick={() => uploadImage()}>Save Image</Button>
      </Stack>


      <FormControl fullWidth>
                  <InputLabel id="brand">Brand</InputLabel>
                  <Select
                    id="brand"
                    value={brand}
                    label="Brand"
                    onChange={handleBrand}
                    name="brand"
                    margin="dense"
                  >
                      {brands?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.brandName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>


    {(selectedStorages.length >= smartphone?.storages?.length) &&
    (
      <Autocomplete
        multiple
        id="tags-standard"
        freeSolo
        options={optionz}
        getOptionLabel={(option) => (option.amount + option.type)}
        defaultValue={selectedStorages}
        name="storages"
        onChange={(e, value) => {
          setCheck(true)
          setSelectedStorages(value)
          smartphone.storages = value
          inFirstOnly(storages, value)
          setFieldValue("storages", value);
        }}
        style={{marginBottom: '15px'}}
        renderInput={(params) => (
          <TextField
            {...params}
            margin="dense"
            variant="standard"
            label="Storages options"
            placeholder="Storages"
            value={values.storages}
          />
        )}
      />
    )}

      <FormControl fullWidth>
                  <InputLabel id="color">Color</InputLabel>
                  <Select
                    id="color"
                    value={color}
                    label="Color"
                    onChange={handleColor}
                    name="color"
                  >
                      {colors?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.colorName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>

    <TextField
        id="price"
        type="number"
        margin="dense"
        value={values.price}
        onChange={handleChange}
        onBlur={handleBlur}
        label={values.price ? "" : "Price"}
      />
      {errors.price && touched.price && (
        <p className="error">{errors.price}</p>
      )}

      <div className="btnContainer">
        <Stack direction="row" spacing={2}>
          {smartphone?.img ?
              (<Button variant="contained" size="small"color="primary" id="submitBtn" type="submit">
              Update
            </Button>) : "Please upload a smartphone image and you will be able to submit"
          } 
          <Button variant="contained" startIcon={<ShoppingBasketIcon />} size="small" color="secondary" id="submitBtn" type="submit" onClick={() => navigate("/smartphones/1")}>
            Shop
          </Button>
        </Stack>
      </div>
    </form>
  }

  </div>
  )

  const renderDesktopEditSmartphone = () => (
    <div id="formContainer" className={isMd ? "mobile" : ""}>

    {(smartphone && finished) &&
    <form onSubmit={handleSubmit} autoComplete="off" id="registerForm">
    <Typography style={{marginTop:'64px', marginBottom:'10px'}} variant="h5" className="center">Edit Smartphone {smartphone.title}</Typography> 
      <FormControl fullWidth style={{marginBottom: '10px'}}>
      <TextField
        id="desc"
        type="text"
        margin="dense"
        value={values.desc}
        onChange={handleChange}
        onBlur={handleBlur}
        label={"Desc"}
        multiline
        rows={5}
        focused
      />
      {errors.desc && touched.desc && (
        <p className="error">{errors.desc}</p>
      )}
      </FormControl>
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '15px'}}>
        <Image cloudName="deqqgmfxk"  publicId={smartphoneImgLink ? smartphoneImgLink : smartphone.img} style={{width: '300px', height: '300px', objectFit:'cover', objectPosition:'center'}}/>
      </div>
      <Stack direction="row" justifyContent="space-between" style={{marginBottom:'15px', marginTop:'15px'}}>
        <Button size="medium" sx={{width: '150px'}} variant="contained" color="secondary"  component="label">
          Upload
          <input hidden accept="image/*" multiple type="file" name="img" id="input" onChange={onFileChange}/>
        </Button>
        <Button size="medium" variant="contained"  sx={{width: '150px'}} onClick={() => uploadImage()}>Save to cloud</Button>
      </Stack>

      <FormControl fullWidth style={{marginBottom: '10px'}}>
                  <InputLabel id="brand">Brand</InputLabel>
                  <Select
                    id="brand"
                    value={brand._id ? brand._id : brand}
                    label="Brand"
                    focused
                    onChange={handleBrand}
                    name="brand"
                    margin="dense"
                  >
                      {brands?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.brandName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}}>
                  <InputLabel id="model">Model</InputLabel>
                  <Select
                    id="model"
                    value={model._id ? model._id : model}
                    label="Model"
                    focused
                    onChange={handleModel}
                    name="model"
                    margin="dense"
                  >
                      {models?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.modelName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}}>
                  <InputLabel id="storage">Storage</InputLabel>
                  <Select
                    id="storage"
                    value={storage._id ? storage._id : storage}
                    label="Storage"
                    focused
                    onChange={handleStorage}
                    name="storage"
                    margin="dense"
                  >
                      {storages?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.amount + option.type}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}}>
                  <InputLabel id="color">Color</InputLabel>
                  <Select
                    id="color"
                    value={color._id ? color._id : color}
                    label="Color"
                    onChange={handleColor}
                    name="color"
                  >
                      {colors?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.colorName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}}>
      <TextField
          id="quantity"
          type="number"
          margin="dense"
          value={values.quantity}
          focused
          onChange={handleChange}
          onBlur={handleBlur}
          label={"Quantity"}
        />
      </FormControl>
      {errors.quantity && touched.quantity && (
        <p className="error">{errors.quantity}</p>
      )}

    <FormControl fullWidth style={{marginBottom: '10px'}}>
    <TextField
        id="price"
        type="number"
        margin="dense"
        value={values.price}
        onChange={handleChange}
        onBlur={handleBlur}
        label={"Price"}
        focused
      />
      {errors.price && touched.price && (
        <p className="error">{errors.price}</p>
      )}
      </FormControl>
      <div className="btnContainer">
        <Stack direction="row" spacing={2}>
          {smartphone?.img ?
              (<Button variant="contained" size="small"color="primary" id="submitBtn" type="submit">
              Update
            </Button>) : "Please upload a smartphone image and you will be able to submit"
          } 
          <Button variant="contained" startIcon={<ShoppingBasketIcon />} size="small" color="secondary" id="submitBtn" type="submit" onClick={() => navigate("/smartphones/1")}>
            Shop
          </Button>
        </Stack>
      </div>
    </form>
  }

  </div>
  )

  return (
    <div>
        {
        (isXs) ?  renderMobileEditSmartphone() : 
        (isSm) ? renderMobileEditSmartphone() :
        (isMd) ? renderMobileEditSmartphone() :
        renderDesktopEditSmartphone()
      }
    </div>
  );
}

export default EditSmartphone